
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners-program",
      function () {
        return require("private-next-pages/partners-program/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners-program"])
      });
    }
  